import React from "react";
import FamilyBG from "../../assets/familyBG.png";
import styled from "styled-components";

const FamilyBusiness = () => {
  return (
    <TheFamily>
      <div className="family-bg">
        <img src={FamilyBG} alt="Family Background" />
      </div>
      <div className="overlay"></div>
      <div className="family-content">
        <h3>WE ARE LOCATED IN HOPKINSVILLE KENTUCKY</h3>
        <h4> - FAMILY OWNED & OPERATED BUSINESS SINCE 2001 -</h4>
      </div>
    </TheFamily>
  );
};

const TheFamily = styled.div`
  width: 100%;
  height: 45vh;
  position: relative;
  overflow: hidden;

  .family-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
    z-index: 2;
  }

  .family-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    z-index: 3;
    width: 80%;
    max-width: 900px;

    h3 {
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 0.8rem;
      letter-spacing: 2px;
      text-transform: uppercase;
      animation: fadeInUp 0.8s ease;
    }

    h4 {
      font-size: 1.1rem;
      font-weight: 400;
      letter-spacing: 1px;
      animation: fadeInUp 0.8s ease 0.2s both;
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Large desktop screens (1366px and below) */
  @media screen and (max-width: 1366px) {
    height: 40vh;

    .family-content {
      width: 85%;

      h3 {
        font-size: 1.8rem;
      }

      h4 {
        font-size: 1rem;
      }
    }
  }

  /* Standard desktop / laptop (1200px and below) */
  @media screen and (max-width: 1200px) {
    height: 38vh;

    .family-content {
      width: 85%;

      h3 {
        font-size: 1.6rem;
      }

      h4 {
        font-size: 0.95rem;
      }
    }
  }

  /* Tablets (900px and below) */
  @media screen and (max-width: 900px) {
    height: 35vh;

    .family-content {
      width: 90%;

      h3 {
        font-size: 1.4rem;
        letter-spacing: 1px;
        margin-bottom: 0.6rem;
      }

      h4 {
        font-size: 0.85rem;
      }
    }
  }

  /* Mobile landscape (600px and below) */
  @media screen and (max-width: 600px) {
    height: 32vh;

    .family-content {
      width: 95%;

      h3 {
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
        letter-spacing: 1px;
      }

      h4 {
        font-size: 0.75rem;
      }
    }
  }

  /* Mobile portrait (420px and below) */
  @media screen and (max-width: 420px) {
    height: 30vh;

    .family-content {
      width: 95%;

      h3 {
        font-size: 0.9rem;
        margin-bottom: 0.4rem;
        letter-spacing: 0.5px;
      }

      h4 {
        font-size: 0.65rem;
      }
    }
  }

  /* Small mobile devices (350px and below) */
  @media screen and (max-width: 350px) {
    height: 28vh;

    .family-content {
      width: 98%;

      h3 {
        font-size: 0.75rem;
        margin-bottom: 0.3rem;
      }

      h4 {
        font-size: 0.55rem;
      }
    }
  }
`;

export default FamilyBusiness;
